// #region imports

// --- Angular
import { Component } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
}
